import { useCallback } from "react";
import { useNavigate } from "react-router-dom-v5-compat";
import { getPackageRoutes } from "@b2bportal/core-utilities";
import { useI18nContext } from "@hopper-b2b/i18n";

export const useHomePagePackageSearch = () => {
  const { t } = useI18nContext();
  const navigate = useNavigate();

  const handleMobileRedirect = useCallback(() => {
    navigate(getPackageRoutes().FULL_ROUTES.SEARCH);
  }, [navigate]);

  return {
    context: {},
    handlers: {
      handleMobileRedirect,
    },
    text: {
      mobileButtonLabel: t("core-packages.search.button"),
    },
  };
};
